<script>
  export default {
    name: 'layout-mensagens-embed'
  }
</script>

<template>
  <div class="cm-embed-wrapper">
    <router-view></router-view>
  </div>
</template>

<style>
  .cm-embed-wrapper {
    margin: 0;
    padding: 0;
    height: 100vh;
    background: #f3f5f7;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/central-mensagens/componentes/LayoutMensagensEmbed.vue